import type { CodingContext } from '@imprivata-cloud/dataprivacy';
import { QueryKey } from '@portal/constants';
import { useMutation, useQuery } from '@tanstack/react-query';
import { addImprIdpDirectory, getImprIdpData } from '../../api/commonServices';
import type { DirectoryAddRequest, ImprDirectoriesConfig } from '../../api/types';
import type { ErrorCode } from '../../errorHandler/constants';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import type { AppError } from '../../errorHandler/errors';

export type AddDirectory = {
  addDirectoryRequest: DirectoryAddRequest;
  codingContext?: CodingContext;
};

const useAddImprIdpDirectory = (url: string, inlineErrorCodes: readonly ErrorCode[] = []) => {
  const { emitError } = useErrorContext();

  return useMutation({
    mutationFn: async (request: AddDirectory) => {
      return addImprIdpDirectory(
        url,
        request.addDirectoryRequest,
        request.codingContext || undefined,
      );
    },
    onError: error => {
      const appError = error as AppError;
      console.log('Error saving Imprivata IDP Directory/Initial User', appError);
      if (appError.code && inlineErrorCodes.includes(appError.code)) {
        return;
      }
      emitError(appError);
    },
  });
};

const useDirectoriesConfig = (isSetup: boolean) => {
  return useQuery<ImprDirectoriesConfig | null>({
    queryKey: [QueryKey.DIRECTORIES_CONFIG],
    queryFn: async () => {
      const response = await getImprIdpData(isSetup);
      return response.directoriesConfig ?? null;
    },
  });
};

export { useAddImprIdpDirectory, useDirectoriesConfig };
